import styled from 'styled-components';
import MuiListItem from '@material-ui/core/ListItem/ListItem';

export const ListItem = styled(MuiListItem)`
  background-color: ${({ selected, theme }) =>
    selected ? theme.palette.background.default : 'inherit'} !important;
`;
